import { component } from 'picoapp'
import $ from 'quantdom'

export default component((node) => {
  $(node).on('click', function (e) {
    e.preventDefault()
    const headerHeight = $('#SiteHeader').el().offsetHeight
    const juHeight = $('.ju_Con').el()?.offsetHeight ?? 0
    const totalHeight = headerHeight + juHeight - 25
    const target = $(node).attr('href')
    const name = $(node).el()?.innerText
    if (window?.gtag) {
      window.gtag('event', 'Jump To Click', {
        event_detail: name,
        event_detail2: target,
      })
    }
    if ($(target).el()) {
      const offset = $(target).el()?.offsetTop
      window.scrollTo(0, offset - totalHeight)
    }
  })
})
